import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { LawFirm } from '../enterprise.types';
import { LawFirmList } from '../../entity/entity-lists/LawFirmList';
import { AllLawFirmsModal } from '../../modals/entity-lists/AllLawFirmsModal';
import { withUser } from '../../user/UserContext';
import { fetchEntrepriseLawFirms } from '../enterprise.api';
import { doctrineAnalytics } from '../../utils/analyticsUtils';
import { EntityInfos } from '../../entity/expertises/infos/EntityInfos';
import { EntityDecisionListModal } from '../../modals/entity-lists/EntityDecisionListModal';
import { withModal, WithModalProps } from '../../components/modal/withModal';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../user/user.types';
import { InjectedIntlProps } from '../../doctrine.types';
import { withEnterprise } from './EnterpriseContext';
import { EnterpriseContextType } from './enterprise.types';
import {
  EntityBlock,
  EntityBlockTitle,
} from '../../entity/components/EntityBlockComponents';
import { SeeMore } from '../../components/see-more/SeeMore';

type Props = {
  displayTitle: Function;
} & WithRestrictedModalProps &
  UserContextType &
  WithModalProps &
  InjectedIntlProps &
  EnterpriseContextType;

type State = {
  lawFirms: Array<LawFirm>;
  hasMore: boolean;
};

export class RawLawFirmsRepresentingEnterprise extends React.Component<
  Props,
  State
> {
  state: State = {
    lawFirms: [],
    hasMore: false,
  };

  source = 'enterprise_law_firms';

  wording = this.props.intl.formatMessage(
    { id: 'app.pages.enterprise.representedBy.wording' },
    { companyName: this.props.enterpriseInfos.raisonSociale },
  );

  async componentDidMount() {
    const {
      enterpriseInfos: { siren },
      displayTitle,
    } = this.props;
    const { lawFirms, hasMore } = (await fetchEntrepriseLawFirms(siren)).data;
    this.setState({ lawFirms, hasMore });
    if (lawFirms.length > 0) {
      displayTitle();
    }
  }

  handleSeeMoreClick = () => {
    const {
      enterpriseInfos: { siren, raisonSociale },
      accessPremium,
      openModal,
      openRestrictedModal,
    } = this.props;
    if (accessPremium) {
      openModal(modalProps => (
        <AllLawFirmsModal
          siren={siren}
          source={this.source}
          raisonSociale={raisonSociale}
          wording={this.wording}
          {...modalProps}
        />
      ));
    } else {
      openRestrictedModal(`${this.source}_see_more`);
    }
    doctrineAnalytics('Enterprise SeeMoreLawFirms', {
      siren,
    });
  };

  handleClickDecision = (lawFirm: LawFirm) => {
    const {
      accessPremium,
      openModal,
      openRestrictedModal,
      enterpriseInfos: { siren },
    } = this.props;
    if (accessPremium) {
      openModal(modalProps => (
        <EntityDecisionListModal
          entityName={lawFirm.nom}
          wording={this.wording}
          params={{
            lawOfficeId: lawFirm.lawOfficeIdGroup,
            siren,
          }}
          {...modalProps}
          source={this.source}
        />
      ));
    } else {
      openRestrictedModal(`${this.source}_decision`);
    }
    doctrineAnalytics('Entity SeeEntityDecisions', {
      source: this.source,
    });
  };

  render() {
    const {
      experience: { decisionCount },
      enterpriseInfos: { raisonSociale },
    } = this.props;
    const { lawFirms, hasMore } = this.state;
    if (!lawFirms.length) return null;
    return (
      <EntityBlock>
        <EntityBlockTitle>
          <FormattedMessage
            id="app.pages.enterprise.representedBy.lawFirm.title"
            values={{ numberOfLawFirms: lawFirms.length }}
          />
        </EntityBlockTitle>
        <EntityInfos
          decisionCount={decisionCount}
          entityType="enterprise"
          entityName={raisonSociale}
        />
        <LawFirmList
          lawFirms={lawFirms}
          source={this.source}
          wording={this.wording}
          handleClickDecision={(lawFirm: LawFirm) =>
            this.handleClickDecision(lawFirm)
          }
        />
        {hasMore && (
          <SeeMore onClick={this.handleSeeMoreClick}>
            <FormattedMessage id="app.pages.enterprise.seeMore" />
          </SeeMore>
        )}
      </EntityBlock>
    );
  }
}

export const LawFirmsRepresentingEnterprise = withEnterprise(
  withUser(
    withModal(
      withRestrictedModal(injectIntl(RawLawFirmsRepresentingEnterprise)),
    ),
  ),
);
